import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=03d6345a&"
import script from "./Template.vue?vue&type=script&lang=js&"
export * from "./Template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d6345a')) {
      api.createRecord('03d6345a', component.options)
    } else {
      api.reload('03d6345a', component.options)
    }
    module.hot.accept("./Template.vue?vue&type=template&id=03d6345a&", function () {
      api.rerender('03d6345a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Components/Template.vue"
export default component.exports